import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { useServer } from "../../../../../services/server"
import { AdjustmentNote, useAdjustmentNoteLoaders } from "../../../../administration"
import { useFiscalDocumentLoaders } from "../../../../fiscal-documents"

export const useActions = (onRefresh?: () => Promise<void>) => {
    const { generateCreditNote: generateCreditNoteRequest } = useServer()

    const fiscalDocumentLoaders = useFiscalDocumentLoaders()
    const adjustmentNoteLoaders = useAdjustmentNoteLoaders()

    const { closeModal } = useUIActions()

    const generateCreditNote = async (adjustmentNote: AdjustmentNote) => {
        Emitter.emit(Event.DB_SUBMIT, 'Enviando nota de crédito a facturar...')

        try {
            await generateCreditNoteRequest(adjustmentNote.id)

            if (onRefresh) {
                await onRefresh()
            } else {
                const { loadOperationFiscalDocuments } = fiscalDocumentLoaders()
                await loadOperationFiscalDocuments(adjustmentNote.operationId, false)
                const { loadOperationAdjustmentNotes } = adjustmentNoteLoaders()
                await loadOperationAdjustmentNotes(adjustmentNote.operationId, false)
            }

            Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo generar la nota de crédito.')
        }
    }

    return {
        generateCreditNote
    }
}
